import actionTypes, * as actionGroups from "sheets/sheet-action-types"
import * as djangioActionCreators from "shared/djangio/action-creators"
import { sendUserActionPost } from "shared/user-actions/user-actions-action-creators"

export const editColumnForm = payload => ({ type: actionTypes.EDIT_COLUMN_FORM, payload })

export const editScorecardItem = (index, payload) => ({ type: actionTypes.EDIT_SCORECARD_ITEM, index, payload })
export const addScorecardItem = () => ({ type: actionTypes.ADD_SCORECARD_ITEM })
export const removeScorecardItem = index => ({ type: actionTypes.REMOVE_SCORECARD_ITEM, index })

// export const searchifyScorecardItem = index => ({ type: actionTypes.SEARCHIFY_SCORECARD_ITEM, index })

const { Sheet, Column } = DjangIO.app.userdata.spreadsheet.models

export const postColumn = (id, kwargs, dataType, numberOfColumnsToCreate) =>
    dispatch =>
        dispatch(djangioActionCreators.resourcePostList(
            Column,
            actionGroups.postColumn,
            kwargs,
            { id }
        )).then(() => {
            sendUserActionPost({
                userActionType: DjangIO.app.useractions.types.UserActionType.sheet_column_created,
                description: `${DjangIO.app.models.QuorumDataType.by_value(dataType).singular} - ${numberOfColumnsToCreate} Columns Created`,
                quorumDataType: dataType,
            })
        })

export const loadSheetForColumnForm = (id, sheetId) =>
    (dispatch, getState) => {
        if (getState().sheet.get(id)) {
            return
        }

        return dispatch( // eslint-disable-line consistent return
            djangioActionCreators.resourceGetDetail(
                Sheet.objects.get(sheetId).fields(["data_type", "name", "columns"]),
                actionGroups.getSheet,
                sheetId,
                { id }
            )
        )
    }

export const columnFormStartSearchify = () =>
    ({ type: actionTypes.START_SHEET_SEARCHIFY, id: 'columnForm' })

export const columnFormStartSearchifyAndEditColumnForm = payload =>
    (dispatch) => {
        dispatch({ type: actionTypes.START_SHEET_SEARCHIFY, id: 'columnForm' })
        dispatch({ type: actionTypes.EDIT_COLUMN_FORM, payload })
    }

export const columnFormCompleteSearchify = () => ({ type: actionTypes.COLUMN_FORM_COMPLETE_SEARCHIFY })

export const initColumnForm = (kwargs={}) => ({ type: actionTypes.INIT_COLUMN_FORM, kwargs })

// action creator to toggle whether the submit button should show loading
export const toggleIsSubmitting = isSubmitting => ({ type: actionTypes.TOGGLE_COLUMN_SUBMITTING, isSubmitting })

export const sheetColumnSubmitSearchify = ({ searchifyFilters }) =>
    (dispatch) => {
        const searchifyValue = {
            added_ids: searchifyFilters.addedIds,
            deleted_ids: searchifyFilters.deletedIds,
            filters: searchifyFilters.querysetList,
        }

        const searchifyCount = searchifyFilters.searchifyCount

        dispatch(editColumnForm({ searchifyValue, searchifyCount }))
    }

export const sheetCustomDataColumnSubmitSearchify = ({ searchifyFilters, uniqueFlvId }) =>
    (dispatch, getState) => {
        const searchifyValue = {
            added_ids: searchifyFilters.addedIds,
        }
        const customDataId = searchifyFilters.addedIds[0]
        const customDatas = getState().search.getIn(['filterableListViews', uniqueFlvId, 'currentData'])
        const customData = customDatas && customDatas.size && customDatas.find(e => e.get('id') === customDataId)
        dispatch(editColumnForm({
            customData,
            searchifyValue,
            custom_data_id: customDataId,
        }))
    }
